/* eslint-env browser */
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Customer } from '@app/models/customers/Customer';
import { CarrentOffer } from '@app/models/offers/CarrentOffer';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptionService } from '@app/services/encyption.service';
import { AuthGuardService } from '@app/services/auth-guard.service';

@Component({
    selector: 'app-offerpackcarrentcard',
    templateUrl: './offerpackcarrentcard.component.html',
    styleUrls: ['./offerpackcarrentcard.component.scss'],
    standalone: false
})
export class OfferpackcarrentcardComponent implements OnInit {
    @Input() offerid: string;
    @Input() offer: CarrentOffer;
    @Input() currentCustomer: Customer;
    @Input() desktopTemplate: string;
    @Input() title: string;
    @Input() booking: any;
    @Input() index: number;
    @Input() reference: string;
    @Output() removeFromList = new EventEmitter<string>();
    @Output() changeindex = new EventEmitter<{dragedindex: number; dropindex: number}>();
    @Output() openSetComment = new EventEmitter<boolean>();

    constructor (
        private encservice: EncryptionService,
        private guardService: AuthGuardService,
        private router: Router
    ) { }

    ngOnInit (): void {
        // console.log(this.offer);
        // console.log(this.objFilter);
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async setCommentModal() {
        this.openSetComment.emit(true);
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        if (Number(dragedindex) > 0 && Number(dragedindex) !== this.index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: this.index - 1 });
        }
    }

    async removeFromListF () {
        this.removeFromList.emit(this.offerid);
    }

    async gotoOffers () {
        window.open(this.offer.link, '_blank')
    }

    async goToBooking () {
        if (this.offerid?.length > 0) {
            this.booking.realparams.offerid = this.offerid;
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt({ offerid: this.offerid, productType: 'carrent', reference: this.reference?.length > 0 ? this.reference : 'offerpack' }) }
            };
            const url = this.router.createUrlTree(['carrent', 'carrentbooking'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }
}
